export const requiredVisitTimerData = [
    { label: "15 Minutes", value: 15 },
    { label: "30 Minutes", value: 30 },
    { label: "1 Hour", value: 60 },
    { label: "2 Hours", value: 120 },
    { label: "3 Hours", value: 180 },
    { label: "4 Hours", value: 240 },
    { label: "5 Hours", value: 300 },
    { label: "6 Hours", value: 360 },
];

export const visitSoonTimerOptionsData = _.fill(Array(12), null).map((o, i) => (i + 1) * 10).map(item => ({ label: `${item} Minutes`, value: item }));

export const bedExitRangeData = [
    { label: "12:00 AM", value: "00:00" },
    { label: "1:00 AM", value: "01:00" },
    { label: "2:00 AM", value: "02:00" },
    { label: "3:00 AM", value: "03:00" },
    { label: "4:00 AM", value: "04:00" },
    { label: "5:00 AM", value: "05:00" },
    { label: "6:00 AM", value: "06:00" },
    { label: "7:00 AM", value: "07:00" },
    { label: "8:00 AM", value: "08:00" },
    { label: "9:00 AM", value: "09:00" },
    { label: "10:00 AM", value: "10:00" },
    { label: "11:00 AM", value: "11:00" },
    { label: "12:00 PM", value: "12:00" },
    { label: "1:00 PM", value: "13:00" },
    { label: "2:00 PM", value: "14:00" },
    { label: "3:00 PM", value: "15:00" },
    { label: "4:00 PM", value: "16:00" },
    { label: "5:00 PM", value: "17:00" },
    { label: "6:00 PM", value: "18:00" },
    { label: "7:00 PM", value: "19:00" },
    { label: "8:00 PM", value: "20:00" },
    { label: "9:00 PM", value: "21:00" },
    { label: "10:00 PM", value: "22:00" },
    { label: "11:00 PM", value: "23:00" },
];

export const rrUrgentTimerOptions = [
    { label: "1 Hour", value: 60 },
    { label: "2 Hours", value: 120 },
    { label: "3 Hours", value: 180 },
    { label: "4 Hours", value: 240 },
    { label: "5 Hours", value: 300 },
    { label: "6 Hours", value: 360 },
];

export const bedExitData = [
    { label: "2 Minutes", value: 120 },
    { label: "5 Minutes", value: 300 },
    { label: "10 Minutes", value: 600 },
    { label: "20 Minutes", value: 1200 },
    { label: "40 Minutes", value: 2400 },
    { label: "60 Minutes", value: 3600 },
];

export const lowWarnOptions = _.times(31).map(item => ({ label: `${item} PR`, value: item }));

export const rrWarningTimerOptions = _.fill(Array(6), null).map((o, i) => ({ label: `${(i + 1) * 10} Minutes`, value: (i + 1) * 10 }));

const chronicCondition = [
    "Congestive Heart Failure",
    "Chronic Obstructive Pulmonary Disease",
    "Diabetes",
    "Hypertension",
    "MCI",
    "Dementia",
    "Alzheimers",
    "Arthritis",
];

export const chronicConditionData = chronicCondition.map(item => ({ label: item, value: item }));

export const uniqueValuesArray = (arr, inputKey) => {
    const table = {};
        return arr
        .map((item) => (item[inputKey]) ? ({ label: item[inputKey], value: inputKey === "bed_name" ? item.id : item[inputKey]}) : (inputKey === "bed_name" ? ({label: "No name", value: item.id}) : ({ label: "", value: "" })))
        .filter(({ label }) => (!table[label] && (table[label] = 1) && label));
}
